import React, { CSSProperties } from 'react';

import { Indent } from '@r1-frontend/ui-react/experimental/containers/IndentContainer';
import { TRadius } from '@r1-frontend/ui-react/experimental/containers/RounderContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export type TTooltipPosition =
| 'bottom-left'
| 'bottom-center'
| 'bottom-right'
| 'right'
| 'top-right'
| 'top-center'
| 'top-left'
| 'left';

/**
* Нужно для того, чтобы тип у {ref} не мог быть string, так как он deprecated
* В оригинальном `React.DOMElement` задаётся `React.LegacyRef<T>`, в котором есть `string`
*/
export interface DOMElement<
    P extends React.HTMLAttributes<T> | React.SVGAttributes<T>,
    T extends Element
> extends React.DOMElement<P, T> {
    ref: React.Ref<T>,
}

export const isDOMTypeElement = <
    P extends React.HTMLAttributes<T> | React.SVGAttributes<T>,
    T extends Element
>(
    element: React.ReactElement,
): element is DOMElement<P, T> => {
    return React.isValidElement(element) && typeof element.type === 'string';
};

export interface ITooltipBodyProps {
    background?: COLORS,
    content: React.ReactNode,
    position?: TTooltipPosition,
    arrowIndent?: Indent,
    radius?: TRadius,
    withArrow?: boolean,
    zIndex?: CSSProperties['zIndex'],
    className?: string,
}

export interface IStatefulTooltipProps extends ITooltipBodyProps {
    gap?: number,
    children: React.ReactElement,
}

export type TTooltipProps = ITooltipBodyProps &
    (
        | {
        gap?: number,
        children: React.ReactElement,
        isShown?: never,
        closeOnClickOutside?: never,
        onClose?: never,
        closeOnScroll?: never,
        closeOnTransition?: never,
          }
        | {
        gap?: number,
        children: React.ReactElement,
        isShown: boolean,
        closeOnClickOutside?: boolean,
        onClose?: () => void,
        closeOnScroll?: boolean,
        closeOnTransition?: boolean,
          }
    );
